import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/radioguide/jpg-png/reinvox-receiver-r-300.png")